export default {
  invoice_manage: '发票管理',

  invoice_info_line_1: '充值资金不支持直接开票，InGame仅支持对',
  invoice_info_line_2: '已消耗的现金金额',
  invoice_info_line_3: '开具发票',
  invoice_info_line_4: '根据税法合规要求，',
  invoice_info_line_5: '增值税专用发票抬头需与账号实名信息严格保持一致',
  invoice_info_line_6:
    '，InGame不支持任何场景的变更专票抬头诉求，如需变更专票抬头，请先修改企业实名认证信息。',

  can_open_amount: '可开票金额(¥)',
  already_open_amount: '实际开票金额(¥)',
  less_open_amount: '剩余可开票金额(¥)',
  invoice_history: '开票记录',
  bill_pay_time: '订单/账单扣费时间',
  bill_pay_money: '实付金额(¥)',
  bill_id: '账单号',
  bill: '账单',
  bill_year: '年',
  bill_month: '月',

  invoice_header_title: '发票信息',
  invoice_header_warn:
    '请您与贵司财务人员核实发票信息，确保信息填写正确，以免影响发票的后续使用',
  manage_invoice_header: '管理发票信息',
  invoice_header_type: '抬头类型',
  enterprise: '企业',
  invoice_type: '发票类型',
  invoice_medium: '发票介质',
  invoice_common: '增值税普通发票',
  invoice_special: '增值税专用发票',
  invoice_header_name: '发票抬头',
  invoice_header_code: '纳税人识别号',
  invoice_bank: '基本开户行',
  invoice_bank_account: '基本开户帐号',
  invoice_address: '企业注册地址',
  invoice_phone: '企业注册电话',
  invoice_id_code_info: '15-20位数字',
  invoice_bank_info: '请填写开户许可证上的开户行',
  invoice_bank_account_info: '请填写开户许可证上的银行账号',
  invoice_cert_info: '请填写营业执照上的注册地址',
  invoice_phone_info: '请填写企业有效的联系电话',

  email_info: '邮箱信息',
  email_manage: '管理邮箱信息',
  email_default: '默认',
  email_set_default: '设为默认',
  email_modify: '修改',
  email_delete: '删除',
  email_title: '电子邮箱',
  email_add: '添加',

  can_invoice_bills: '可开票订单',
  bill_as_detail: '按消费明细',
  bill_as_month: '按月账单汇总',
  bill_product_name: '产品名称',

  apply_invoice: '申请开票',
  apply_total_invoice_amount: '总开票金额',
  apply_item_name: '项目名称',
  apply_specification_model: '规格型号',
  apply_unit: '单位',
  apply_quantity: '数量',
  apply_unit_price: '单价(¥)',
  apply_amount: '金额(¥)',
  apply_tax_rate: '税率',
  apply_tax_amount: '税额(¥)',
  apply_modify: '去修改',
  apply_electronic_invoice: '数电发票',
  apply_electronic_invoice_note:
    '数电发票默认不显示购买方及销售方的开户行，若期望显示，请手动勾选：',
  apply_receive_email: '接收邮箱',
  apply_invoice_remarks_optional: '发票备注（可选）',
  apply_invoice_remarks_note: '填写后打印在发票的备注内留区域',
  apply_invoice_remarks_limit:
    '发票备注不可超过230个字节，一个中文字符为2个字节',
  apply_next_step: '下一步',
  down_invoice: '下载数电发票',
  invoice_id: '发票号码',
  invoice_status: '发票状态',
  apply_invoice_time: '申请开票时间',
  apply_invoice_road: '申请开票方式',
  manual_apply_invoice: '手动申请开票',
  invoice_status_applying: '申请中',
  invoice_status_opening: '开票中',
  invoice_status_success: '开票成功',
  invoice_status_fail: '开票失败',
  invoice_confirm: '确认开票信息',
  invoice_preview: '发票预览',
  invoice_apply_failed: '提交申请失败',
  invoice_have_apply: '开票申请已提交',
  invoice_view_in_email: '后续请在预留电子邮箱中查收',
  invoice_preview_info_1:
    '请您与贵司财务人员核实发票信息，确保信息填写正确，以免影响发票的后续使用；当日开具发票最快可于次日前往国家税务总局全国增值税发票查验平台验证。',
  invoice_preview_info_2:
    '如开票涉及多种税率，会分别开票，请以实际开票税率为准。云服务类产品税率6%，货物或应税劳务、服务名称为“信息技术服务“云服务费”，软件类产品税率13%，货物或应税劳务、服务名称为“软件“软件产品销售”，不可更改。',

  invoice_electron_info:
    '数电发票默认不展示购买方及销售方的开户行，若期望展示，请手动勾选：',
  invoice_show_buyer: '展示购买方',
  invoice_show_seller: '展示销售方',
};
